import Lyric from './Lyric'

/**
 * 酷狗逐字歌词
 * @see http://tapd.oa.com/tme_music_lib/prong/stories/view/1020369272064474753 附件
 */
export default class Krc extends Lyric {
  constructor(type = 'lyricKugou') {
    super(type)
    this._template = `[id:$00000000]
[ar:__singerName__]
[ti:__trackName__]
[by:__author__]
__content__`

    this.nameExt = '_krc'
  }

  /**
   *
   * @override
   */
  _getWordMark(lineTime, wordObj) {
    const round = Math.round

    return `<${round(wordObj.start - lineTime[0])},${round(wordObj.duration)},0>${wordObj.word}`
  }
}
